import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'

// import styles from './style.module.scss'
import drawIcon from '@assets/images/icon/draw-icon.svg'
import usePoll from '@shared/hooks/usePoll'
import { S3_PREFIX } from '@shared/constants'
import { abbreviateNumber } from '@shared/utils'

const PollStyle = dynamic(() => import('@shared/components/multiPoll/pollStyle'))
const MyImage = dynamic(() => import('@shared/components/myImage'))

function MatchPoll({ poll, teamOneImage, teamTwoImage }) {
  const { t } = useTranslation()
  const { pollData, handleAnswer, isActive, getPercentage, message, isExpired, selectedOption } = usePoll({ poll })
  const [render, setRender] = useState()

  useEffect(() => {
    setRender({ selectedOption })
  }, [selectedOption])
  return (
    <PollStyle>
      {(pollStyle) => (
        <section className="widget common-box">
          <h3 className="small-head d-flex align-items-center mb-0 mt-n1">{pollData?.sTitle}</h3>
          <div className="d-flex my-2 mx-n1 text-center">
            {pollData?.aField?.map((o, i) => {
              if (i === 1) {
                return (
                  <div key={o?._id} className="d-flex flex-column" onClick={() => handleAnswer(o?._id)}>
                    <div
                      className={`${pollStyle.option} ${pollStyle.draw} c-pointer d-flex align-items-center justify-content-center py-3 mx-1 px-2 br-xs mb-2 position-relative overflow-hidden`}
                    >
                      <div className={`${pollStyle.flag} mw-100`}>
                        <MyImage
                          src={drawIcon}
                          alt="draw"
                          width="20"
                          height="20"
                        />
                      </div>
                      <div
                        style={{ height: render?.selectedOption || isExpired ? getPercentage(o?.nVote) + '%' : 0 }}
                        className={`${pollStyle.result} ${
                          pollStyle?.[isActive(o?._id)]
                        } position-absolute bottom-0 start-0 w-100 c-transition`}
                      />
                    </div>
                    <p className="mb-0 small-text">
                      {o?.sTitle} {render?.selectedOption || isExpired ? `(${getPercentage(o?.nVote)}%)` : ''}
                    </p>
                  </div>
                )
              } else {
                return (
                  <div key={o?._id} className={`${pollStyle.item} d-flex flex-column`} onClick={() => handleAnswer(o?._id)}>
                    <div
                      className={`${pollStyle.option} c-pointer d-flex align-items-center justify-content-center py-3 mx-1 br-xs mb-2 position-relative overflow-hidden`}
                    >
                      <div className={`${pollStyle.flag} rounded-circle overflow-hidden`}>
                        <MyImage
                          src={`${S3_PREFIX}${i === 0 ? teamOneImage?.sUrl : teamTwoImage?.sUrl}`}
                          alt="team"
                          width="20"
                          height="20"
                          className="aspect-ratio"
                        />
                      </div>
                      <div
                        style={{ height: render?.selectedOption || isExpired ? getPercentage(o?.nVote) + '%' : 0 }}
                        className={`${pollStyle.result} ${
                          render?.selectedOption ? pollStyle?.[isActive(o?._id)] : ''
                        } position-absolute bottom-0 start-0 w-100 c-transition`}
                      />
                      {/* {(render?.selectedOption || isExpired) && (
                        <h3 className={`${pollStyle.value} small-head mb-2 font-medium position-absolute bottom-0 start-0 w-100`}>{getPercentage(o?.nVote)}%</h3>
                      )} */}
                    </div>
                    <p className="mb-0 small-text">
                      {o?.sTitle} {render?.selectedOption || isExpired ? `(${getPercentage(o?.nVote)}%)` : ''}
                    </p>
                  </div>
                )
              }
            })}
          </div>
          <div className="d-flex justify-content-between pt-md-1 mb-n1">
            <div className="fw-light">{message}</div>
            <div className="text-capitalize font-semi">
              {t('common:Votes')} {abbreviateNumber(pollData?.nTotalVote)}
            </div>
          </div>
        </section>
      )}
    </PollStyle>
  )
}
MatchPoll.propTypes = {
  poll: PropTypes.object,
  teamOneImage: PropTypes.object,
  teamTwoImage: PropTypes.object
}
export default MatchPoll
